import * as React from 'react'

import { Button, type Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  archived: boolean
  draft: boolean
  archiveHandler: () => void
  deleteHandler: () => void
  archivable?: boolean
}

const BaseButtom = ({
  handler,
  text,
  icon,
  disable,
}: {
  handler: () => void
  text: string
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
  disable?: boolean
}) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip attachment="bottom center" open={open} size="small" toggle={toggle} type="black">
      <Button onClick={handler} type="secondary" iconName={icon} disabled={disable} />
      {text}
    </Tooltip>
  )
}

const IconButton = ({
  archived,
  archiveHandler,
  draft,
  deleteHandler,
  archivable = true,
}: Props) => {
  if (draft) {
    return (
      <BaseButtom
        handler={deleteHandler}
        icon="delete"
        text={i18n.t('settings.legal_entities.legal_entity.contracts.modal.options.remove')}
      />
    )
  }

  const icon = archived ? 'archive-open' : 'archive'
  let tooltipText = i18n.t('settings.legal_entities.legal_entity.contracts.modal.options.archive')

  if (archived) {
    tooltipText = i18n.t('settings.legal_entities.legal_entity.contracts.modal.options.unarchive')
  }

  if (!archivable) {
    tooltipText = i18n.t(
      'settings.legal_entities.legal_entity.contracts.modal.options.no_archivable'
    )
  }

  return (
    <BaseButtom handler={archiveHandler} icon={icon} text={tooltipText} disable={!archivable} />
  )
}

export default observer(IconButton)
